<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="Authors’ Note">
<h2 class="fmt"><span epub:type="pagebreak" id="page_xviii" title="xviii"><a href="#/text/Contents#toc4" id="rtoc4"><span class="cb">Authors’ Note</span></a></span></h2>
<p class="indent_parat">This book was undertaken shortly after it was proposed in late 2018. In-person interviews began the following January and continued until the coronavirus pandemic struck in early 2020. This interrupted our ability to do in-person interviews but did not slow other research or the task of composition. It was difficult to assess the virus’s long-term effects on Amtrak at first. Now, we see it dramatically disrupted the company and threatened its survival along with that of other modes of passenger transportation. Ultimately, we chose to discuss the future of Amtrak under normal conditions, so most of what we recommend cannot occur until the pandemic subsides, and then only if a failure by Congress to provide emergency funding and major changes by Amtrak management in the fall of 2020 do not end up killing the patient.</p>
<p class="indent_para">In the meantime, the state of Florida is proposing three hundred miles of new highways costing $26 billion.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Authors_Note.vue?7ef62d32